if (!customElements.get('preorder-button-sync')) {
  customElements.define('preorder-button-sync', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.button = this.form?.querySelector('button[name="add"]');
      this.label = this.button?.querySelector('span');
      if (!this.form || !this.label) return;
      this.config = JSON.parse(this.querySelector('script').textContent);
      this.sync = () => {
        const id = this.form.querySelector('input[name="id"]')?.value;
        if (!Object.prototype.hasOwnProperty.call(this.config.variants, id)) return;
        const isPreorder = this.config.variants[id];
        const payment = this.form.querySelector('[data-preorder-payment]');
        if (payment) {
          payment.hidden = isPreorder;
          if (isPreorder) payment.style.display = 'none';
          else payment.style.removeProperty('display');
        }
        if (this.button.disabled) return;
        const text = isPreorder ? 'Pre-order' : this.config.addLabel;
        if (this.label.textContent.trim() !== text) this.label.textContent = text;
      };
      this.form.addEventListener('change', this.sync);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.button, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
        characterData: true
      });
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.form?.removeEventListener('change', this.sync);
    }
  });
}
